export default "__VITE_ASSET__Tbgqd4Qq__"